export function compareByLabel<T extends { label: string }>(left: T, right: T) {
  return left.label.localeCompare(right.label);
}
